//Hooks
import { get } from 'svelte/store';
//Formating
import { format } from 'svelte-i18n';
//Types
import type { WebHooksParams } from 'src/types/requests/settings/webhooks';
import type { Condition } from '../rules/webhook_conditions_rules';

export const buildVirtualWebhookLabels = (hook: WebHooksParams, conditionRule: Condition) => {
	const $format = get(format);
	let label = '';
	let operant = (conditionRule?.operant as string) || '';
	let value = conditionRule?.value || '';
	if (operant == '===') {
		operant = $format('condition_is', {
			default: 'is',
		});
	} else if (operant == '!==') {
		operant = $format('condition_is_not', {
			default: 'is not',
		});
	}
	if (hook.enums) {
		const _enum = hook.enums.find((i) => String(i.value) === String(value));
		if (_enum) {
			hook.icon = _enum?.icon || hook.icon;
			value = _enum.title;
		}
		if (hook?.icon) {
			if (_enum?.icon && /^(true|false)$/.test(_enum?.value)) {
				if (conditionRule?.operant === '!==') {
					const _enum = hook.enums.find((i) => i.value != value);
					if (_enum) {
						hook.icon = _enum?.icon;
						value = _enum.title;
					}
				}
				label = `${value}`;
			} else {
				label = `${operant} ${value}`;
			}
		}
		if (!/^(bthomesensor)\./.test(hook.event)) {
			label = `${hook?.title || ''} ${operant} ${value}`;
		}
	} else if (hook.icon && /^(bthomesensor)\./.test(hook.event)) {
		label = `${operant} ${value} ${hook.unit || ''}`;
	} else if (conditionRule?.event === 'ev.idx' && /(_push|rotate_(left|right))/.test(hook.event)) {
		return buildVirtualButtonLabels(hook, value as string);
	} else {
		label = `${
			hook?.title || (conditionRule?.event ? $format(conditionRule?.event as string) : '')
		} ${operant} ${value} ${hook.unit || ''}`;
	}
	return {
		label,
		icon: hook.icon || 'fas fa-cube',
	};
};

export const buildVirtualButtonLabels = (hook: WebHooksParams, channel = '') => {
	const $format = get(format);
	const eventTitle = `input_${hook.event
		.replace('_push', 'push')
		.replace(/((bthome(sensor|device))\.)/g, 'button_')
		.replace(/(single)/g, '')}`;
	const label =
		$format(`option_${eventTitle.replace('.', '_')}`, {
			default: eventTitle.replace(/(\.|_)/g, ' '),
		}) + (channel ? ` (${channel})` : '');
	return {
		label,
		icon: 'far fa-hand-back-point-up',
	};
};
